import React from "react";
import { useNavigate } from "react-router";
import { thirdPartySignInAndUp } from "supertokens-web-js/recipe/thirdpartypasswordless";
import { DECCAN_URL, PRAJAVANI_EMAIL_TAB, REDIRECT_URL } from "../contant";
import { toast } from "react-toastify";
import LoaderComponent from "../component/LoaderComponent";

export default function ThirdPartyCallbackScreen() {
  const navigate = useNavigate();
  const callbackUrl = localStorage.getItem("callbackUrl") || "";

  React.useEffect(() => {
    const handleThirdPartyProviderCallback = async () => {
      localStorage.setItem(
        "tab_detail",
        callbackUrl?.toLowerCase()?.includes(DECCAN_URL)
          ? "Email"
          : PRAJAVANI_EMAIL_TAB
      );

      try {
        const response = await thirdPartySignInAndUp();
        if (response.status === "OK") {
          localStorage.setItem(
            "access-token",
            response.fetchResponse.headers.get("st-access-token")
          );
          localStorage.setItem(
            "refresh-token",
            response.fetchResponse.headers.get("st-refresh-token")
          );
          localStorage.setItem(
            "user_login_detail",
            JSON.stringify({
              email: response.user.emails[0],
              phone: "",
            })
          );
          if (
            response.createdNewRecipeUser &&
            response.user.loginMethods.length === 1
          ) {
            navigate("/auth/authenticate");
            // sign up successful
          } else {
            // navigate("/auth/profile")
            window.location.assign(
              // sign in successful St-Access-Token St-Refresh-Token
              `${callbackUrl}?access_token=${response.fetchResponse.headers.get(
                "st-access-token"
              )}&refresh_token=${response.fetchResponse.headers.get(
                "st-refresh-token"
              )}`
            );
          }
        } else if (response.status === "SIGN_IN_UP_NOT_ALLOWED") {
          // this can happen due to automatic account linking. Please see our account linking docs
        } else {
          toast.error(
            "No email provided by social login. Please use another form of login"
          );
          navigate(`/auth?${REDIRECT_URL}=${callbackUrl}`); // redirect back to login page
        }
      } catch (err) {
        console.log("callback-error", err);
        if (err.isSuperTokensGeneralError === true) {
          toast.error(err.message);
          // this may be a custom error message sent from the API by you.
        } else {
          console.log("err", err);
        }
      }
    };
    handleThirdPartyProviderCallback();
    return () => {
      // Additional cleanup logic if needed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoaderComponent label="Signing in..." />;
}
